module.exports = __webpack_public_path__ + "static/media/bowalia.c65824b6.png";